import { combineReducers } from 'redux';
import { allReducers } from '@ace/react-utilities';

const rootReducer = combineReducers(allReducers);

export default rootReducer;